import {useSelector} from 'react-redux';
import {ProtocolEditorViewMode, ViewMode} from 'constants/dataEnum';
import {getAppViewMode} from 'stores/selectors/appStateSelectors';
import {getProtocolEditorMode} from 'stores/selectors/protocolEditorSelectors';

function useShowStatusbar() {
  const currentViewMode = useSelector(getAppViewMode);
  const currentProtocolEditorMode = useSelector(getProtocolEditorMode);
  const isInAllowedProtocolEditorMode =
    currentProtocolEditorMode !== ProtocolEditorViewMode.SERIAL_DILUTION &&
    currentProtocolEditorMode !== ProtocolEditorViewMode.NORMALIZATION;

  const allowedPages = [
    ViewMode.USER_MANAGEMENT,
    ViewMode.EXPLORER,
    ViewMode.PROTOCOL_EDITOR,
    ViewMode.RUNTIME,
    ViewMode.DISPENSE_REPORT_EXPLORER,
    ViewMode.LABWARE_MANAGER,
    ViewMode.LOG_LIST,
    ViewMode.ABOUT,
  ];

  const shouldShowStatusbar = allowedPages.includes(currentViewMode) && isInAllowedProtocolEditorMode;

  return shouldShowStatusbar;
}

export default useShowStatusbar;
